import React from "react";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";
import TooltipLabel from "js/common/views/tooltip-label";

const errorStyle = (theme) => ({
  color: theme.palette.button.alert,
  fontSize: 10,
  position: "absolute"
});

const FormField = ({
  children,
  required = false,
  filled = false,
  label,
  customLabelStyle,
  customTooltipStyle,
  tooltip,
  errorMessage
}) => {
  const {theme} = React.useContext(CustomThemeContext);
  return (
      <div>
        {label && (
            <TooltipLabel
                label={label}
                tooltip={tooltip}
                customLabelStyle={customLabelStyle}
                customTooltipStyle={customTooltipStyle}>
              {required && (
                  <i
                      className={!errorMessage && filled ? "bhi-check" : "fa fa-circle"}
                      style={{
                        color: errorMessage
                            ? theme.palette.error.main
                            : filled
                                ? theme.palette.success.main
                                : theme.palette.error.main,
                        marginLeft: "0.5rem",
                        fontSize: errorMessage || !filled ? "0.5rem" : "0.9rem"
                      }}
                  />
              )}
            </TooltipLabel>
        )}
        {children}
        {errorMessage && <span style={errorStyle(theme)}>{errorMessage}</span>}
      </div>
  );
};

export default FormField;
